import GetCard from './Get'

export {
    GetCard
}